import { Injectable } from '@angular/core';
import { HhsgSharedStuderDepartment } from '../../models/sgportal-data-api-models/department.model';
import { HhsgSharedStuderEmployee } from '../../models/sgportal-data-api-models/employee.model';
import { HhsgSharedStuderJobTitle } from '../../models/sgportal-data-api-models/job-title.model';
import { HhsgSharedStuderLeader } from '../../models/sgportal-data-api-models/leader.model';
import { HhsgSharedStuderSaveDepartmentResult } from '../../models/sgportal-data-api-models/save-department-result.model';
import { HhsgSharedConfigService } from '../config.service';
import { HhsgSharedHttpService } from '../http.service';

@Injectable()
export class HhsgSharedStuderDepartmentService {
    public departmentCount: number;
	private readonly _controllerName: string = 'Department';
    private readonly _sgPortalApiServer: string;

	constructor(private _configService: HhsgSharedConfigService, private _httpService: HhsgSharedHttpService) {
        this._sgPortalApiServer = _configService.appSettings.sgPortalApiServer;
    }

	public getDepartmentsForOrganization(organizationId: number): Promise<HhsgSharedStuderDepartment[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderDepartment[]>(
            this._sgPortalApiServer, 
            this._controllerName, 
            `GetDepartments/${organizationId}`);
	}

	public getActiveDepartmentsWithEmployeeCount(organizationId: number): Promise<HhsgSharedStuderDepartment[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderDepartment[]>(
            this._sgPortalApiServer,
            this._controllerName, 
            `GetActiveDepartmentsWithEmployeeCount/${organizationId}`);
	}

	public getDepartmentInfo(departmentId: number, organizationId: number): Promise<HhsgSharedStuderDepartment> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderDepartment>(
            this._sgPortalApiServer,
            this._controllerName, 
            `GetDepartmentInfo/${departmentId}/${organizationId}`);
	}

	public getLeaderListForOrganization(organizationId: number): Promise<HhsgSharedStuderLeader[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderLeader[]>(
            this._sgPortalApiServer,
            'Leader', 
            `GetLeaderModelsForOrganization/${organizationId}`);
	}

	public getEmployeeDivisionJobTitleByDept(departmentId: number): Promise<HhsgSharedStuderEmployee[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderEmployee[]>(
            this._sgPortalApiServer,
            this._controllerName, 
            `GetEmployeeDivisionJobTitleByDept/${departmentId}`);
	}

	public getJobTitlesByDepartment(departmentId: number, organizationId: number): Promise<HhsgSharedStuderJobTitle[]> {
		return this._httpService.doGetRequestAsync<HhsgSharedStuderJobTitle[]>(
            this._sgPortalApiServer,
            this._controllerName, 
            `GetJobTitlesByDepartment/${departmentId}/${organizationId}`);
	}

	public saveDepartment(deptModel: HhsgSharedStuderDepartment): Promise<HhsgSharedStuderSaveDepartmentResult> {
		return this._httpService.doPostRequestAsync<any, HhsgSharedStuderSaveDepartmentResult>(
            this._sgPortalApiServer,
            this._controllerName, 
            'SaveDepartment', 
            deptModel);
	}

	updateDepartment(deptModel: HhsgSharedStuderDepartment): Promise<HhsgSharedStuderSaveDepartmentResult> {
		return this._httpService.doPostRequestAsync<any, HhsgSharedStuderSaveDepartmentResult>(
            this._sgPortalApiServer,
            this._controllerName, 
            'UpdateDepartment', 
            deptModel);
	}

	public deleteDepartment(deptModel: HhsgSharedStuderDepartment): Promise<void> {
		return this._httpService.doPostRequestAsync<any, void>(
            this._sgPortalApiServer,
            this._controllerName, 
            'DeleteDepartment', 
            deptModel);
	}

	public saveDepartmentJobTitle(departmentId: number, jobTitles: HhsgSharedStuderJobTitle[]) {
		return this._httpService.doPostRequestAsync(
            this._sgPortalApiServer,
            this._controllerName, 
            `SaveDepartmentJobTitle/${departmentId}`, 
            jobTitles);
	}
}
